export const environment = {
  production: true,
  apiUrl: 'https://ecocentri.servizi.mquadro.net/api/v1',
};

export const service_order = {
  production: true,
  defaultGridColumns: ['ods_id', 'assignedLicensePlate',  'description', 'start_date', 'end_date', 'ts_ods_start', 'ts_ods_end', 'duration', 'route',  'status', 'group', 'operations'],
  gridColumns: ['ods_id', 'assignedLicensePlate',  'description', 'start_date', 'end_date', 'ts_ods_start', 'ts_ods_end', 'duration', 'route',  'status', 'group', 'operations']
};
// ['ods_id', 'description', 'start_date', 'end_date', 'ts_ods_start', 'ts_ods_end', 'assignedLicensePlate', 'status', 'route','group', 'operations'],

export const mapURL = {
  production: true,
  defaultMapUrl: 'https://mapservice.mquadro.net',
  mapUrl: '${mapURL}'
};
